/* eslint-disable import/no-extraneous-dependencies */
import React, { Component } from 'react';
import { compose, withHandlers, pure } from 'recompose';
import { MsalContext } from '@azure/msal-react';
import Buttons from '../../core/Buttons';
import Label from '../../core/Label';
import Input from '../../core/Input';
import Alerts from '../../core/Alerts';
import ModalForgetPassword from './ModalForgetPassword';
import LogoAtresmedia from '../../../../assets/images/logoatresmedia.svg';
import {
  StyledWrapper,
  StyledWrapperLogin,
  StyledLogo,
  StyledTextLogin
  // StyledLogoRazor
} from './style';
import { login } from '../../../utils/apiLogin';

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isValidUser: true,
      showForgetModal: false,
      errorUser: '',
      errorPassword: '',
      fromPathname: '',
      disabled: false
    };
  }

  componentDidMount() {
    if (this.props.location && this.props.location.state) {
      const fromPathname = this.props.location.state.from.pathname;
      this.setState({ fromPathname });
    }
  }

  redirectLogin = async () => {
    const { instance } = this.context;
    try {
      await instance.loginRedirect();
    } catch (error) {
      throw error;
    }
  };

  storeUserWidget = async data => {
    let res = false;
    const { ipcRenderer } = window.require('electron');
    const stored = await ipcRenderer.sendSync('stored-loggin', data);
    if (stored) {
      res = true;
    }
    return res;
  };

  onLogin = data => {
    this.setState({ disabled: true });
    const { fromPathname } = this.state;
    if (data.username === '') {
      this.setState({ errorUser: 'Campo obligatorio' });
    } else {
      this.setState({ errorUser: '' });
    }
    if (data.password === '') {
      this.setState({ errorPassword: 'Campo obligatorio' });
    } else {
      this.setState({ errorPassword: '' });
    }

    if (data.username !== '' && data.password !== '') {
      login(data)
        .then(() => {
          this.setState({ isValidUser: true });
          if (this.props.isWidget) {
            this.storeUserWidget(data);
            this.props.history.replace(`/widget/noticias`);
            return;
          }
          if (fromPathname) {
            this.props.history.replace(fromPathname);
          } else {
            this.props.history.replace(``);
          }
          this.setState({ disabled: false });
        })
        .catch(error => {
          // Recogemos código de error (comprobando que no es una descripción)
          const errorCode = Number.isNaN(parseInt(error.message, 10))
            ? '500' // Error Interno Servidor
            : error.message;
          this.setState({ errorCode, isValidUser: false, disabled: false });
        });
    } else {
      this.setState({ errorCode: 'X', isValidUser: false, disabled: false });
    }
  };

  render() {
    const {
      isValidUser,
      showForgetModal,
      errorUser,
      errorPassword,
      errorCode,
      disabled
    } = this.state;
    const { className, isWidget } = this.props;

    return (
      <StyledWrapper className={className} isWidget={isWidget}>
        <StyledWrapperLogin className="login-wrapper" isWidget={isWidget}>
          {isWidget ? (
            <React.Fragment>
              <StyledTextLogin className="login-text" isWidget={isWidget}>
                Entra al widget{' '}
              </StyledTextLogin>
              <div className="login-credentials">
                <Label label="Usuario" className="login-label mb-5" />
                <Input id="username" className="mb-15" error={errorUser} />
                <Label label="Contraseña" className="login-label mb-5" />
                <Input
                  id="password"
                  type="password"
                  className="mb-30"
                  error={errorPassword}
                />
              </div>
              <div className="login-buttons">
                <Buttons
                  onClick={() => {
                    this.setState({ showForgetModal: true });
                  }}
                  className="login-enter login-enter--password"
                  transparent
                >
                  Restablecer contraseña
                </Buttons>
                <Buttons
                  onClick={() =>
                    this.onLogin({
                      username: document.getElementById('username').value,
                      password: document.getElementById('password').value
                    })
                  }
                  secondary
                  className="login-enter login-enter--start"
                  disabled={disabled}
                >
                  Entrar
                </Buttons>
              </div>
              <div className="login-msj">
                {!isValidUser && (
                  <Alerts
                    type={isWidget ? 'light' : 'error'}
                    visible={!isValidUser}
                  >
                    [{errorCode}] Usuario o contraseña no válidos
                  </Alerts>
                )}
              </div>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <StyledLogo svg={LogoAtresmedia} />
              <StyledTextLogin>Bienvenido/a a la Intranet </StyledTextLogin>
              <div className="login-credentials">
                <Label
                  label="Para acceder haga click en el botón e introduzca sus credenciales de Microsoft
                   en la nueva ventana"
                  className="login-label-active-directory"
                />
              </div>
              <div className="login-buttons">
                <Buttons
                  onClick={this.redirectLogin}
                  secondary
                  className="login-enter login-enter--start"
                >
                  Entrar
                </Buttons>
              </div>
            </React.Fragment>
          )}
        </StyledWrapperLogin>
        {showForgetModal && (
          <ModalForgetPassword
            clickCloseIcon={() => {
              this.setState({ showForgetModal: false });
            }}
          />
        )}
      </StyledWrapper>
    );
  }
}
Login.contextType = MsalContext;
export default compose(pure, withHandlers())(Login);
